import React from 'react';
import { Card } from '../../../components/Card';
import { Section } from '../../../components/Section';
import { StatusPill } from '../../../components/StatusPill';
import { IconWrap } from '../../../components/IconWrap';
import {
    CiSearch,
    CiFileOn,
    CiFilter,
    CiUser,
    CiFileOn as CiBriefcase,
} from 'react-icons/ci';
import useTheme from '../../../hooks/useTheme';

export const HowHubWorks: React.FC = () => {
    const { theme, breakpoint } = useTheme();

    const steps = [
        {
            number: 1,
            title: 'Discover needs',
            status: 'LIVE' as const,
            icon: <CiSearch />,
            bullets: [
                'Browse public events and news',
                'Contact BCBH team directly',
            ],
        },
        {
            number: 2,
            title: 'Submit opportunity brief',
            status: 'COMING SOON' as const,
            icon: <CiFileOn />,
            bullets: [
                'Submit through Opportunities Exchange',
                'Provide company and project details',
            ],
        },
        {
            number: 3,
            title: 'Screening & categorization',
            status: 'COMING SOON' as const,
            icon: <CiFilter />,
            bullets: [
                'BCBH team reviews submissions',
                'Categorize by sector and type',
            ],
        },
        {
            number: 4,
            title: 'Introductions & meetings',
            status: 'PARTLY LIVE' as const,
            icon: <CiUser />,
            bullets: [
                'Direct introductions facilitated',
                'Meetings arranged (virtual/physical)',
            ],
        },
        {
            number: 5,
            title: 'Missions / tenders support',
            status: 'COMING SOON' as const,
            icon: <CiBriefcase />,
            bullets: [
                'Business mission coordination',
                'Tender collaboration support',
            ],
        },
    ];

    return (
        <Section style={{ backgroundColor: theme.background.panel }}>
            <h2
                style={{
                    fontSize: '34px',
                    fontWeight: 700,
                    color: theme.text.primary,
                    marginBottom: '48px',
                    textAlign: 'center',
                }}
                className="sectionTitle"
            >
                How the Hub Works (Phase 1 → Phase 3)
            </h2>

            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${breakpoint.xs ? 1 : 3}, minmax(200px, 1fr))`,
                    gap: '20px',
                    position: 'relative',
                }}
                className="hubWorksGrid"
            >
                {steps.map((step, idx) => (
                    <div key={idx} style={{ position: 'relative' }}>
                        {idx < steps.length - 1 && (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '24px',
                                    left: 'calc(100% - 10px)',
                                    width: '20px',
                                    height: '2px',
                                    backgroundColor: theme.colors.line,
                                    zIndex: 0,
                                }}
                                className="stepConnector"
                            />
                        )}
                        <Card hoverable style={{ height: '100%', position: 'relative', zIndex: 1 }}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    marginBottom: '16px',
                                }}
                            >
                                <div
                                    style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        backgroundColor:
                                            step.status === 'LIVE' || step.status === 'PARTLY LIVE'
                                                ? theme.colors.green.g1
                                                : theme.background.panel,
                                        color:
                                            step.status === 'LIVE' || step.status === 'PARTLY LIVE'
                                                ? theme.text.primary
                                                : theme.text.muted,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '20px',
                                        fontWeight: 700,
                                        border:
                                            step.status === 'LIVE' || step.status === 'PARTLY LIVE'
                                                ? 'none'
                                                : `2px solid ${theme.colors.line}`,
                                    }}
                                >
                                    {step.number}
                                </div>
                                <StatusPill status={step.status} size="small" />
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    marginBottom: '12px',
                                }}
                            >
                                <IconWrap icon={step.icon} size={24} color="primary" />
                                <h3
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: 600,
                                        color: theme.text.primary,
                                    }}
                                >
                                    {step.title}
                                </h3>
                            </div>

                            <ul
                                style={{
                                    listStyle: 'none',
                                    padding: 0,
                                    margin: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '6px',
                                }}
                            >
                                {step.bullets.map((bullet, bulletIdx) => (
                                    <li
                                        key={bulletIdx}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '8px',
                                            fontSize: '13px',
                                            color: theme.text.muted,
                                            lineHeight: 1.5,
                                        }}
                                    >
                                        <span
                                            style={{
                                                color:
                                                    step.status === 'LIVE' || step.status === 'PARTLY LIVE'
                                                        ? theme.colors.green.g1
                                                        : theme.text.muted,
                                                marginTop: '4px',
                                                flexShrink: 0,
                                            }}
                                        >
                                            •
                                        </span>
                                        {bullet}
                                    </li>
                                ))}
                            </ul>
                        </Card>
                    </div>
                ))}
            </div>
        </Section>
    );
};

